import { DateFormat, TimeFormat } from 'Constants/Configuration'
import { Col, DatePicker, Row, TimePicker } from 'antd'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import { useAppSelector } from 'hooks'
import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/plugin/utc'
import { PropsWithChildren, useCallback } from 'react'
import { TranslationKeys } from 'Constants/TranslationKeys'
import { getHtmlParentElement, renderTranslation } from 'Helpers/GenericHelpers'

export type DateTimeFilterProps = {
  showTime?: boolean
  dateFrom?: Dayjs
  dateTo?: Dayjs
  className?: string
  lblClassName?: string
  dateClassName?: string
  timeClassName?: string
  disableFrom?: boolean
  disableTo?: boolean
  hideFrom?: boolean
  hideTo?: boolean
  disableElement?: boolean
  sizeComponent?: SizeType
  onDateFromChange?: any //It passes the external function that decides the DatePicker's behaviour on change
  onDateToChange?: any
  onTimeFromChange?: any //It passes the external function that decides the TimePicker's behaviour on change
  onTimeToChange?: any
  inColumn?: boolean
  fullFormat?: boolean //Time if not set, Date + Time if set
  setStatusFrom?: 'error' | 'warning' | undefined //sets status From/To
  setStatusTo?: 'error' | 'warning' | undefined
  setDisableDateFrom?: any
  setDisableDateTo?: any
  setDisableTimeFrom?: any
  setDisableTimeTo?: any
  setShowTime?: object | boolean //sets a specific value for showtime property
  setOnOkFrom?: any //actions on ok From/To
  setOnOkTo?: any
  setModalFix?: boolean //fix modal problem
  setDateFrom?: any //sets starting value property for DataPicker, default is undefined
  setDateTo?: any
}
export default function DateTimeRangeFilter(props: DateTimeFilterProps) {
  const language = useAppSelector(state => state.present.language.value)
  const baseClass = props.className || 'datetime-picker-container'

  const dateClassName = props.dateClassName || 'daterangefilter-date'
  const timeClassName = props.timeClassName || 'daterangefilter-time'

  const size: SizeType = props.sizeComponent ? props.sizeComponent : 'middle'

  function Container(containerProps: PropsWithChildren) {
    return props.inColumn ? (
      <Col className={baseClass}>{containerProps.children}</Col>
    ) : (
      <Row className={baseClass}>{containerProps.children}</Row>
    )
  }
  const generatePicker = useCallback(
    (
      date: any,
      placeholderText: any,
      onDateChange: any,
      setDisabled: boolean,
      setDisabledDate: any,
      setDisabledTime: any,
      setStatus: 'error' | 'warning' | undefined,
      setOnOk: any,
      time: any,
      onTimeChange: any,
    ) => {
      return (
        <>
          <DatePicker
            size={size}
            className={dateClassName}
            value={date}
            format={props.fullFormat ? DateFormat + ' ' + TimeFormat : DateFormat}
            placeholder={placeholderText}
            onChange={onDateChange}
            disabled={props.disableElement || setDisabled}
            disabledDate={setDisabledDate}
            disabledTime={setDisabledTime}
            status={setStatus}
            showTime={props.setShowTime}
            onOk={setOnOk}
            getPopupContainer={props.setModalFix && getHtmlParentElement}
          />
          {props.showTime ? (
            <TimePicker
              size={size}
              className={timeClassName}
              value={time}
              format={TimeFormat}
              onChange={onTimeChange}
              disabled={props.disableElement || setDisabled}
              showNow={false}
            />
          ) : null}
        </>
      )
    },
    [props.setDateFrom, props.setDateTo],
  )

  return (
    <Container>
      {!props.hideFrom
        ? generatePicker(
            props.setDateFrom,
            renderTranslation(language, TranslationKeys.availabilitiesDateFilterFrom),
            props.onDateFromChange,
            props.disableFrom,
            props.setDisableDateFrom,
            props.setDisableTimeFrom,
            props.setStatusFrom,
            props.setOnOkFrom,
            dayjs(props.dateFrom).utc(),
            props.onTimeFromChange,
          )
        : null}
      {!props.hideTo
        ? generatePicker(
            props.setDateTo,
            renderTranslation(language, TranslationKeys.availabilitiesDateFilterTo),
            props.onDateToChange,
            props.disableTo,
            props.setDisableDateTo,
            props.setDisableTimeTo,
            props.setStatusTo,
            props.setOnOkTo,
            dayjs(props.dateTo).utc(),
            props.onTimeToChange,
          )
        : null}
    </Container>
  )
}
